import { render, staticRenderFns } from "./disabled-actions.vue?vue&type=template&id=2261b17e"
import script from "./disabled-actions.vue?vue&type=script&lang=js"
export * from "./disabled-actions.vue?vue&type=script&lang=js"
import style0 from "./disabled-actions.vue?vue&type=style&index=0&id=2261b17e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports